import React, { useRef, useState } from 'react';
import { Button, TextareaAutosize, CircularProgress } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import clsx from 'clsx';

import { postRequest } from 'utils/api';
import { setGigMessage } from 'features/gigsSlice';
import AttachIcon from 'public/icons/attach.svg';
import styles from 'styles/components/gigs/Chat.module.scss';

const TypingSection = ({ removeFile, file, setFile, isLoading, setIsLoading, gig }) => {
  const [message, setMessage] = useState('');

  const fileRef = useRef(null);
  const disabled = (message === '' && !file) || isEmpty(gig);
  const dispatch = useDispatch();

  const handleFileClick = () => fileRef.current.click();

  const createMessage = () => {
    const data = new FormData(); // eslint-disable-line no-undef

    if (file) data.set('file', file);

    data.set('body', message);

    setIsLoading(prevState => ({ ...prevState, sendMessage: true }));

    postRequest({
      endpoint: `conversations/${gig.id}/messages?conversation_type=Gig`,
      data,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    })
      .then(response => {
        dispatch(setGigMessage(response.data));
        setMessage('');
        setFile(null);

        setIsLoading(prevState => ({ ...prevState, sendMessage: false }));
      })
      .catch(() => setIsLoading(prevState => ({ prevState, sendMessage: false })));
  };

  return (
    <div className={styles.typingSection}>
      <div className={styles.typing}>
        <input ref={fileRef} onChange={e => setFile(e.target.files[0])} type="file" name="file" />

        <AttachIcon
          onClick={handleFileClick}
          width={15}
          height={15}
          className={clsx('hover-icon', styles.attachIcon)}
        />

        <TextareaAutosize
          value={message}
          name="message"
          type="text"
          placeholder="Message"
          variant="outlined"
          color="primary"
          onChange={e => setMessage(e.target.value)}
          className={styles.textField}
          maxRows={4}
        />

        <Button
          onClick={createMessage}
          disabled={disabled || isLoading.sendMessage}
          variant="contained"
          color="primary"
        >
          {isLoading.sendMessage ? <CircularProgress color="primary" size={30} /> : 'Send'}
        </Button>
      </div>

      {file && (
        <div className={styles.fileContainer}>
          <div className={styles.file}>File: {file.name}</div>
          <span onClick={removeFile}>Remove</span>
        </div>
      )}
    </div>
  );
};

export default TypingSection;
